<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Vendas</h1>
        <paragrafo>
          Local onde é acessado o relatório das vendas da loja. Há diversas
          possíveis combinações para poder extrair o relatório que se deseja.
          Use os campos: nome do consumidor, e-mail do consumidor, código do
          pedido, status do pedido, regional, forma de pagamento, datas de
          pedido, nome da loja e canal de vendas.
        </paragrafo>
        <imagem :src="image_1" />
        <paragrafo
          >Há a possibilidade de realizar os cancelamentos das movimentações
          clicando no ícone “Cancelar pedido”
          <img :src="image_2" class="icones" /> e confirmar no botão “Sim”.
        </paragrafo>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Vendas",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Vendas/vendas1.png",
      image_2: "/documentacao/vendas/vendas2.png",
    };
  },
};
</script>
<style scoped>
.icones {
  width: 32px;
  height: 28px;
  border-radius: 10px;
}
</style>
>
